import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="min-h-screen">
      <section className="py-20 md:py-32 bg-gradient-to-br from-slate-50 via-emerald-50 to-green-50">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="inline-flex items-center gap-3 bg-white/80 backdrop-blur px-6 py-3 rounded-3xl text-sm font-bold text-primary shadow-lg">
                <i className="fas fa-mosque"></i>
                Islamic School
              </span>
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-black bg-gradient-to-r from-primary via-primary-600 to-emerald-600 bg-clip-text text-transparent mt-8 mb-8 leading-tight">
                Empowering Students
                <br />
                with Islamic Values
              </h1>
              <p className="text-xl md:text-2xl text-slate-700 mb-12 max-w-xl leading-relaxed">
                Join a nurturing community where faith, knowledge, and leadership grow together through balanced learning and character development.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/admission" className="bg-gradient-to-r from-primary to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white px-12 py-6 rounded-3xl font-bold text-lg shadow-2xl hover:shadow-3xl hover:-translate-y-2 transition-all duration-300 inline-flex items-center gap-3">
                  <i className="fas fa-user-plus"></i>
                  Apply Now
                </Link>
                <Link to="/about" className="border-2 border-slate-300 hover:border-primary text-slate-800 hover:text-primary px-12 py-6 rounded-3xl font-bold text-lg shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all duration-300 inline-flex items-center gap-3">
                  <i className="fas fa-arrow-right"></i>
                  Learn More
                </Link>
              </div>
            </div>
            <div className="relative">
              <div className="bg-white/70 backdrop-blur-xl p-12 rounded-4xl shadow-2xl border border-white/50">
                <i className="fas fa-school text-8xl text-primary/80 mb-8 block mx-auto"></i>
                <h3 className="text-3xl font-bold text-primary mb-6 text-center">Modern Islamic Learning</h3>
                <p className="text-xl text-slate-600 text-center leading-relaxed">Primary to senior secondary programs blending Quranic studies with STEM excellence</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-24">
            <h2 className="text-5xl md:text-6xl font-black mb-6 bg-gradient-to-r from-slate-900 to-slate-800 bg-clip-text">
              Why Choose Us?
            </h2>
            <p className="text-2xl text-slate-600 max-w-3xl mx-auto">Excellence in Islamic Education and Character Building</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="group hover:-translate-y-4 transition-all duration-500 p-10 rounded-3xl bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200 hover:border-primary hover:shadow-2xl cursor-pointer">
              <div className="w-20 h-20 bg-gradient-to-br from-primary to-primary-600 text-white rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-all">
                <i className="fas fa-quran text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center">Islamic Studies</h3>
              <p className="text-lg text-slate-600 leading-relaxed text-center">Comprehensive Quran memorization, Arabic language, and Islamic jurisprudence with qualified teachers.</p>
            </div>
            <div className="group hover:-translate-y-4 transition-all duration-500 p-10 rounded-3xl bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200 hover:border-primary hover:shadow-2xl cursor-pointer">
              <div className="w-20 h-20 bg-gradient-to-br from-primary to-primary-600 text-white rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-all">
                <i className="fas fa-graduation-cap text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center">Modern Curriculum</h3>
              <p className="text-lg text-slate-600 leading-relaxed text-center">Balanced education combining Islamic teachings with contemporary academic excellence.</p>
            </div>
            <div className="group hover:-translate-y-4 transition-all duration-500 p-10 rounded-3xl bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200 hover:border-primary hover:shadow-2xl cursor-pointer">
              <div className="w-20 h-20 bg-gradient-to-br from-primary to-primary-600 text-white rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-all">
                <i className="fas fa-users text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center">Qualified Teachers</h3>
              <p className="text-lg text-slate-600 leading-relaxed text-center">Experienced educators dedicated to nurturing both academic and spiritual growth.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

